<template lang="pug">
  ods-form.login-form.login-form--password(
    :model='passwordForm'
    :rules='rules'
    ref='passwordForm'
    :hide-required-asterisk="true")
    template(v-if='emailSent===0')
      div
        template()
        div(align='center')
          img(:src='getImgUrl()')
        h1.login-form__title {{ $t('login.title_new_pass') }}
        p.login-form__description {{ $t('login.message_new_pass') }}
        .login-form__errors.ods-mb-5
          ods-alert(
            class="ods-alert ods-alert--error"
            v-show='errors'
            :title='$t("login.error.user_not_found")',
            type='error',
            :closable='false')
        ods-form-item(:label='$t("login.userLabel")' prop='username')
          ods-input(
            :class='{error: errors}',
            type='text',
            v-model='passwordForm.username')
        ods-form-item(:label='$t("login.emailLabel")', prop='email')
            ods-input(
              type='email',
              v-model='passwordForm.email',
              auto-complete='off')
      div.ods-mt-8.login-form__actions
        router-link(:to='back' tag='div')
          ods-button.ods-p-32(type='neutral') {{ $t('login.backLoginForm') }}
        ods-button.ods-button__custom(type='primary', native-type='submit', @click.prevent="recaptcha('passwordForm')") {{ $t('buttons.btnSend') }}
    div.password-messages(v-else)
      template(v-if='emailSent===-1')
        img(src='../../assets/images/login/email-error.svg' style='padding-bottom: 30px; padding-left: 150px; padding-top: 120px;')
        p {{ $t('login.error.email_without_account') }}
    router-link(v-if='emailSent===-1' to='/login' tag='div' style='padding-top: 30px; padding-left: 140px;')
      ods-button(type='primary') {{ $t('buttons.btnFinish') }}
</template>

<script>
import { mapActions } from 'vuex'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, { siteKey: '6Lfe-xElAAAAAJy4OEl_B8gvDGuxFplCEFKYvhMd', loaderOptions: { autoHideBadge: true } })

export default {
  name: 'login-password-form-generic',
  mixins: [Utils],
  props: {
    logo: {
      type: String
    },
    next: {
      type: String
    },
    back: {
      type: String
    }
  },
  data () {
    const validateEmail = (rule, value, callback) => {
      if (this.checkCorrectEmail(value)) {
        callback()
      } else if (value == null || value === '') {
        callback()
      } else {
        callback(new Error(this.$t('msg_generics.emailKo')))
      }
    }
    return {
      passwordForm: {
        username: '',
        email: null
      },
      rules: {
        username: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'submit' }
        ],
        email: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { validator: validateEmail, trigger: 'change' }
        ]
      },
      errors: false,
      emailSent: 0
    }
  },
  methods: {
    ...mapActions([
      'login',
      'loader',
      'resetPassChallengeSolved',
      'resetPassChallenge',
      'recoveryPassUserState'
    ]),

    getImgUrl () {
      if (this.logo !== null) {
        return require('../../assets/images/login/' + this.logo)
      } else {
        return ''
      }
    },

    getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },
    recaptcha (formName) {
      console.log('recaptcha clicked')
      this.$recaptchaLoaded().then(() => {
        console.log('recaptcha loaded')
        this.$recaptcha('login').then((token) => {
          console.log(token) // Will print the token
          this.submitForm(formName, token)
        })
      })
    },
    submitForm (formName, token) {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid && this.passwordForm.username) {
          try {
            await this.resetPassChallengeSolved({
              username: this.passwordForm.username,
              email: this.passwordForm.email,
              responseCaptcha: token
            })
            this.$notify({
              title: this.$t('login.messageMail'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            console.log('this.back ', this.back)
            switch (this.back) {
              case '/quiron':
                router.push({
                  name: 'loginquiron'
                })
                break
              case '/hipoges':
                router.push({
                  name: 'loginhipoges'
                })
                break
              case '/ohla':
                router.push({
                  name: 'loginohl'
                })
                break
              case '/redelectrica':
                router.push({
                  name: 'loginree'
                })
                break
              case '/renfe':
                router.push({
                  name: 'loginrenfe'
                })
                break
              case '/EECG':
                router.push({
                  name: 'loginufgas'
                })
                break
              case '/CanalSA':
                router.push({
                  name: 'logincanal'
                })
                break
              case '/lyntia':
                router.push({
                  name: 'loginlyntia'
                })
                break
              case '/correosexpress':
                router.push({
                  name: 'logincorreos'
                })
                break
              case '/telefonica':
                router.push({
                  name: 'logintee'
                })
                break
              case '/accionaenergia':
                router.push({
                  name: 'loginaccionaenergia'
                })
                break
              case '/vocento':
                router.push({
                  name: 'loginvocento'
                })
                break
              case '/red.es':
                router.push({
                  name: 'loginredes'
                })
                break
              default:
                router.push({
                  name: 'login'
                })
                break
            }
          } catch (error) {
            this.getNotificationErrorMessage(error)
            this.errors = true
            this.emailSent = -1
          } finally {
            this.$refs.passwordForm.resetFields()
          }
          return true
        } else {
          console.log('valid: ', valid)
          return false
        }
      })
    }
  },
  mounted () {
    setTimeout(() => {
      const recaptcha = this.$recaptchaInstance
      recaptcha.showBadge()
    }, 1000)
  },
  beforeDestroy () {
    const recaptcha = this.$recaptchaInstance
    recaptcha.hideBadge()
  }
}
</script>

<style lang="scss" scoped>
.login__password-msg {
  text-align: center;

  &__text {
    padding: $space-500 0 $space-100 0;
    text-align: left;
    @include txt-body-400;
    color: var(--color-txt-secondary);
  }

  &__email {
    padding-bottom: $space-300;
    text-align: left;
    @include txt-title-150;
  }

  &__actions {
    text-align: left;
  }
}

.login-form__title {
    font-size: 0.875rem;
    font-weight: 500;
    font-style: normal;
    line-height: 1.25rem;
    padding-bottom: 0.5rem;
}
.login-form__description {
    font-size: 0.75rem;
    font-weight: 400;
    font-style: normal;
    line-height: 1rem;
    padding-bottom: 1rem;
    color: var(--color-txt-secondary);
}
.login-form__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4rem;
}
</style>
